import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=dbf3016a&scoped=true&"
import script from "./CampaignTable.vue?vue&type=script&lang=js&"
export * from "./CampaignTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTable.vue?vue&type=style&index=0&id=dbf3016a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf3016a",
  null
  
)

export default component.exports